'use strict';

/**
 * AdminDatasetsController - contrôleur de gestion des jeux de données
 */
import appModule from '../../app.module';

angular.module(appModule)
.controller('AdminDatasetsController', ['$scope', '$http', '$uibModal', 'MockDataService', function($scope, $http, $uibModal, MockDataService) {
  
  // Initialisation des variables de pagination
  $scope.currentPage = 1;
  $scope.itemsPerPage = 10;
  $scope.itemsPerPageOptions = [5, 10, 25, 50];
  $scope.totalItems = 0;
  $scope.totalPages = 0;
  
  // Rendre Math accessible dans la vue
  $scope.Math = window.Math;
  
  // Tri
  $scope.sortField = 'title';
  $scope.sortReverse = false;
  
  // Filtres
  $scope.filters = {
    status: {
      Published: true,
      Draft: true,
      Archived: true
    },
    featured: null
  };
  
  // Récupération des jeux de données depuis le MockDataService
  var allDatasets = MockDataService.getAllDatasets();
  
  // Formater les dates pour l'affichage
  allDatasets.forEach(function(dataset) {
    dataset.publicationDate = new Date(dataset.createdAt);
  });
  
  
  // Fonction de recherche et de chargement des jeux de données
  function loadDatasets() {
    // Tentative de chargement depuis l'API (sera en échec en mode développement)
    var apiUrl = '/api/admin/datasets?page=' + ($scope.currentPage - 1) + 
                '&size=' + $scope.itemsPerPage + 
                '&sort=' + $scope.sortField + ',' + ($scope.sortReverse ? 'desc' : 'asc');
    
    $http.get(apiUrl)
      .then(function(response) {
        $scope.datasets = response.data.content;
        $scope.totalItems = response.data.totalElements;
        $scope.totalPages = response.data.totalPages;
      })
      .catch(function() {
        console.log('Utilisation des données simulées pour le développement');
        
        // Appliquer les filtres
        var filteredDatasets = allDatasets.slice(); // Copie du tableau
        
        // Filtre par statut
        filteredDatasets = filteredDatasets.filter(function(dataset) {
          return $scope.filters.status[dataset.status];
        });
        
        // Filtre par featured
        if ($scope.filters.featured !== null) {
          filteredDatasets = filteredDatasets.filter(function(dataset) {
            return dataset.isFeatured === $scope.filters.featured;
          });
        }
        
        // Filtre par recherche
        if ($scope.searchQuery) {
          var query = $scope.searchQuery.toLowerCase();
          filteredDatasets = filteredDatasets.filter(function(dataset) {
            return dataset.title.toLowerCase().includes(query) || 
                   dataset.organization.toLowerCase().includes(query) ||
                   (dataset.description && dataset.description.toLowerCase().includes(query)) ||
                   (dataset.tags && dataset.tags.some(function(tag) {
                     return tag.toLowerCase().includes(query);
                   }));
          });
        }
        
        // Tri des résultats
        filteredDatasets.sort(function(a, b) {
          var aValue = a[$scope.sortField];
          var bValue = b[$scope.sortField];
          
          // Traitement spécial pour certains champs
          if ($scope.sortField === 'publicationDate' || $scope.sortField === 'createdAt' || $scope.sortField === 'updatedAt') {
            aValue = new Date(aValue || 0).getTime();
            bValue = new Date(bValue || 0).getTime();
          } else if (typeof aValue === 'string' && typeof bValue === 'string') {
            aValue = aValue.toLowerCase();
            bValue = bValue.toLowerCase();
          }
          
          // Comparaison
          if (aValue < bValue) return $scope.sortReverse ? 1 : -1;
          if (aValue > bValue) return $scope.sortReverse ? -1 : 1;
          return 0;
        });
        
        // Paginer les résultats filtrés
        $scope.datasets = filteredDatasets.slice(
          ($scope.currentPage - 1) * $scope.itemsPerPage, 
          $scope.currentPage * $scope.itemsPerPage
        );
        $scope.totalItems = filteredDatasets.length;
        $scope.totalPages = Math.ceil(filteredDatasets.length / $scope.itemsPerPage);
      });
  }
  
  // Génération des numéros de page pour la pagination
  $scope.getPages = function() {
    var pages = [];
    var startPage = Math.max(1, $scope.currentPage - 2);
    var endPage = Math.min($scope.totalPages, $scope.currentPage + 2);
    
    for (var i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    
    return pages;
  };
  
  // Changement de page
  $scope.setPage = function(page) {
    if (page < 1 || page > $scope.totalPages) {
      return;
    }
    $scope.currentPage = page;
    loadDatasets();
  };
  
  // Changer le nombre d'éléments par page
  $scope.setItemsPerPage = function(items) {
    $scope.itemsPerPage = items;
    $scope.currentPage = 1; // Retour à la première page
    loadDatasets();
  };
  
  // Fonction pour changer le tri
  $scope.changeSort = function(field) {
    if ($scope.sortField === field) {
      // Inverser l'ordre si on clique sur la même colonne
      $scope.sortReverse = !$scope.sortReverse;
    } else {
      // Nouvelle colonne de tri, par défaut ascendant
      $scope.sortField = field;
      $scope.sortReverse = false;
    }
    loadDatasets();
  };
  
  // Appliquer les filtres
  $scope.applyFilters = function() {
    $scope.currentPage = 1; // Retour à la première page
    loadDatasets();
  };
  
  // Réinitialiser les filtres
  $scope.resetFilters = function() {
    $scope.searchQuery = '';
    $scope.filters = {
      status: {
        Published: true,
        Draft: true,
        Archived: true
      },
      featured: null
    };
    $scope.currentPage = 1;
    loadDatasets();
  };
  
  // Exporter les données au format CSV
  $scope.exportCSV = function() {
    // En-têtes CSV
    var csvContent = 'ID,Titre,Description,Organisation,Date de création,Date de modification,Statut,Mis en avant\n';
    
    // Contenu des lignes
    allDatasets.forEach(function(dataset) {
      var row = [
        dataset.id,
        '"' + (dataset.title || '').replace(/"/g, '""') + '"',
        '"' + (dataset.description || '').replace(/"/g, '""') + '"',
        '"' + (dataset.organization || '').replace(/"/g, '""') + '"',
        dataset.createdAt || '',
        dataset.updatedAt || '',
        dataset.status || '',
        dataset.isFeatured ? 'Oui' : 'Non'
      ];
      csvContent += row.join(',') + '\n';
    });
    
    // Générer le fichier et le télécharger
    var encodedUri = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvContent);
    var link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'datasets_' + new Date().toISOString().split('T')[0] + '.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  
  // Prévisualiser un jeu de données
  $scope.previewDataset = function(dataset) {
    var modalInstance = $uibModal.open({
      templateUrl: 'app/admin/datasets/dataset-preview.html',
      controller: 'DatasetPreviewController',
      size: 'lg',
      resolve: {
        dataset: function() {
          return angular.copy(dataset);
        }
      }
    });
  };
  
  // Ouvrir la modal pour créer un nouveau jeu de données
  $scope.openNewDatasetModal = function() {
    var modalInstance = $uibModal.open({
      templateUrl: 'app/admin/datasets/dataset-form.html',
      controller: 'DatasetFormController',
      resolve: {
        dataset: function() {
          return { 
            title: '', 
            description: '', 
            status: 'Draft',
            isFeatured: false,
            tags: []
          };
        }
      }
    });
    
    modalInstance.result.then(function(newDataset) {
      // Ajouter le nouveau dataset à la liste globale
      allDatasets.unshift(newDataset);
      // Recharger les données pour afficher le nouveau dataset
      loadDatasets();
      // Afficher un message de succès
      alert('Jeu de données créé avec succès');
    });
  };
  
  // Éditer un jeu de données existant
  $scope.editDataset = function(dataset) {
    var modalInstance = $uibModal.open({
      templateUrl: 'app/admin/datasets/dataset-form.html',
      controller: 'DatasetFormController',
      resolve: {
        dataset: function() {
          return angular.copy(dataset);
        }
      }
    });
    
    modalInstance.result.then(function(updatedDataset) {
      // Mettre à jour le dataset dans la liste globale
      var index = allDatasets.findIndex(function(d) { return d.id === updatedDataset.id; });
      if (index !== -1) {
        allDatasets[index] = updatedDataset;
      }
      // Recharger les données pour afficher les modifications
      loadDatasets();
      // Afficher un message de succès
      alert('Jeu de données mis à jour avec succès');
    });
  };
  
  // Supprimer un jeu de données
  $scope.deleteDataset = function(dataset) {
    if (confirm('Êtes-vous sûr de vouloir supprimer le jeu de données "' + dataset.title + '" ?')) {
      // Simuler une suppression API
      $http.delete('/api/datasets/' + dataset.id)
        .then(function() {
          // Suppression réussie
        })
        .catch(function() {
          console.log('Simulation de suppression en mode développement');
          
          // Supprimer de la liste globale
          var index = allDatasets.findIndex(function(d) { return d.id === dataset.id; });
          if (index !== -1) {
            allDatasets.splice(index, 1);
          }
          
          // Recharger les données
          loadDatasets();
          
          // Afficher un message de succès
          alert('Jeu de données supprimé avec succès');
        });
    }
  };
  
  // Observer les changements dans la recherche pour actualiser les données
  $scope.$watch('searchQuery', function() {
    loadDatasets();
  });
  
  // Charger les données initiales
  loadDatasets();
}]);
